var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.723 67.25h17.553M44.723 72.037h17.553M30.035 20.819H77.91M33.418 20.819l2.83-7.212h34.226l3.051 7.101M25.486 45.67v-3.494h-6.713V29.861h6.213v-6.047m0 0V11h4.882v9.763l-4.881 3.051zM82.18 45.67v-3.494h6.713V29.861H82.68v-6.047m0 0V11h-4.882v9.763l4.882 3.051zM18.774 76.902V50.72l6.712-5.048 4.992 2.496H77.52l4.77-2.496 6.047 5.048v26.183H91v9.764h-3.828v6.601H74.635v-6.601h-42.27v6.601H19.939v-6.601H16v-9.764h2.774z",
    stroke: "#2E5ECC",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 20.974V48.1",
    stroke: "#2E5ECC",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.793 76.825h69.415M41.133 78.42V62.463h24.734V78.42M23.58 70.043V63.26h9.974v6.782H23.58zM73.447 70.043V63.26h9.974v6.782h-9.974z",
    stroke: "#2E5ECC",
    strokeWidth: 3
  })));
}

export default SvgQuoteTruck;